import { Component, Host, OnInit } from '@angular/core';
import { ModalComponent } from '@app/shared/dialogs/modal/modal.component';

export interface ModalActions {
  labelGetter: () => string;
  primary: boolean;
  isDisabled: () => boolean;
  onClick: () => void;
}

@Component({
  standalone: false,
  selector: 'modal-actions',
  templateUrl: './modal-actions.component.html',
})
export class ModalActionsComponent implements OnInit {
  constructor(@Host() public modal: ModalComponent) {}

  ngOnInit() {}
}
